var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.7822,
    y: 14.4277,
    width: 7.92525,
    height: 2.37731,
    rx: 1.18865,
    transform: "rotate(90 27.7822 14.4277)",
    fill: "#BBC2CF",
    stroke: "#BBC2CF",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.292,
    y: 8.50977,
    width: 13.6499,
    height: 2.37731,
    transform: "rotate(90 19.292 8.50977)",
    fill: "#BBC2CF",
    stroke: "#BBC2CF",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.4248,
    y: 14.4277,
    width: 19.3575,
    height: 2.37731,
    rx: 1.18865,
    fill: "#BBC2CF",
    stroke: "#BBC2CF",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8018,
    y: 14.4277,
    width: 7.92525,
    height: 2.37731,
    rx: 1.18865,
    transform: "rotate(90 10.8018 14.4277)",
    fill: "#BBC2CF",
    stroke: "#BBC2CF",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.61306,
    cy: 24.0564,
    r: 2.15642,
    stroke: "#BBC2CF",
    strokeWidth: 2.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1033,
    cy: 24.0564,
    r: 2.15642,
    stroke: "#BBC2CF",
    strokeWidth: 2.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1033,
    cy: 6.6697,
    r: 2.15642,
    stroke: "#BBC2CF",
    strokeWidth: 2.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5935,
    cy: 24.0564,
    r: 2.15642,
    stroke: "#BBC2CF",
    strokeWidth: 2.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavManage);
export default __webpack_public_path__ + "static/media/nav-manage.7420e7e66d80f628c592a49af7c38183.svg";
export { ForwardRef as ReactComponent };